import {asyncActions} from '../lib/asyncUtil'

class NetworkManager {
  constructor(client) {
    this.client = client

    this.readEndpoint = this.readEndpoint.bind(this)
    this.createResource = this.createResource.bind(this)
    this.updateResource = this.updateResource.bind(this)
    this.deleteResource = this.deleteResource.bind(this)
  }

  #response({dispatch, response, actionName}) {
    if (response.success)
      dispatch(asyncActions(actionName).success(response))
    else
      dispatch(asyncActions(actionName).failure(true, response.message))
  }

  #error({dispatch, error, actionName}) {
    dispatch(asyncActions(actionName).failure(true, error.message))
  }

  readEndpoint(dispatch, actionName) {
    return endpoint => {
      dispatch(asyncActions(actionName).loading(true))

      return new Promise((resolve, reject) => {
        this.client.read(endpoint).then(response => {
          this.#response({dispatch, response, actionName})

          resolve(response)
        }).catch(error => {
          console.error(error.message)

          this.#error({dispatch, error, actionName})
          reject(error)
        })
      })
    }
  }

  createResource(dispatch, actionName) {
    return ({endpoint, attributes}) => {
      dispatch(asyncActions(actionName).loading(true))

      return new Promise((resolve, reject) => {
        this.client.post(endpoint, attributes).then(response => {
          this.#response({dispatch, response, actionName})

          resolve(response)
        }).catch(error => {
          console.error(error.message)

          this.#error({dispatch, error, actionName})
          reject(error)
        })
      })
    }
  }

  updateResource(dispatch, actionName) {
    return ({endpoint, method = 'PATCH', attributes}) => {
      const update = method === 'PUT' ? this.client.put : this.client.patch

      dispatch(asyncActions(actionName).loading(true))

      return new Promise((resolve, reject) => {
        update(endpoint, attributes).then(response => {
          this.#response({dispatch, response, actionName})

          resolve(response)
        }).catch(error => {
          console.error(error.message)

          this.#error({dispatch, error, actionName})
          reject(error)
        })
      })
    }
  }

  deleteResource(dispatch, actionName) {
    return endpoint => {
      dispatch(asyncActions(actionName).loading(true))

      return new Promise((resolve, reject) => {
        this.client.delete(endpoint).then(response => {
          this.#response({dispatch, response, actionName})

          resolve(response)
        }).catch(error => {
          console.error(error.message)

          this.#error({dispatch, error, actionName})
          reject(error)
        })
      })
    }
  }
}

export default NetworkManager
